import { useI18n } from '@i18n/useI18n';
import { useEffect, useRef, useState, Fragment } from 'react';
import { Item, MapItemBorder, Popup } from './MapItem.styled';

interface IProps {
  opacity?: any;
  disable?: boolean;
  data?: any;
  index: any;
  isvisible: any;
  row?: any;
}

export const MapItem = (props: IProps) => {
  const [showPopup, setShowPopup] = useState(false);
  const position = useRef({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);
  const i18n = useI18n();
  const show = (e) => {
    position.current = { x: e.target.offsetLeft, y: e.target.offsetTop };
    setShowPopup(true);
  };
  useEffect(() => {
    if (props.isvisible) setOpacity(props.opacity);
  }, [props.isvisible, props.opacity]);

  return (
    <MapItemBorder>
      <Item
        onMouseOut={() => (showPopup ? setShowPopup(false) : null)}
        onMouseOver={(e) => (!showPopup ? show(e) : null)}
        disable={props.disable}
        opacity={opacity}
      ></Item>
      {showPopup ? (
        <Popup position={position.current} index={props.index} row={props.row}>
          <p>
            {i18n.t('total-lessons')}: {props.data && props.data.lessons ? props.data.lessons : 0}
          </p>
          <p>
            {i18n.t('lessons-missed')}: {props.data && props.data.absence_lessons ? props.data.absence_lessons : 0}
          </p>
          <p>
            {i18n.t('time-missed')}: {props.data && props.data.absence_duration ? props.data.absence_duration / 60 : 0} {i18n.t('minutes')}
          </p>
          <p>
            {i18n.t('total-time')}: {props.data && props.data.duration ? props.data.duration / 60 : 0} {i18n.t('minutes')}
          </p>
          <p>
            {i18n.t('absence')}: {props.data && props.data.secondpercentage ? (props.data.secondpercentage * 100).toFixed(1) : 0} %
          </p>
        </Popup>
      ) : null}
    </MapItemBorder>
  );
};

export default MapItem;
